import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import './tips.styles.css';

class TipsComponent extends Component {
    render() {
        return <Alert className="tip" color={this.props.color}>
            {this.props.children}
        </Alert>
    }
}

export default TipsComponent;



// WEBPACK FOOTER //
// ./src/componentes/tips/tips.component.js